import { Button, Grid, Group, Layout, Page, Text } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import {
    TGridSchema,
    useAuth,
    useFetch,
    useForm,
    useGrid,
    useModal,
    usePage,
    useResource,
    useStore,
    useToast,
} from "@/comn/hooks";
import {
    APIS,
    SF_API_TKN,
    SF_API_TKN_SRCH,
    SG_API_TKN_LIST,
    URLS,
} from "@/tra/tancis/ptli/mypage/apitknmng/service/PtliApiTknMgmtService";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Radio } from "@/comn/components/_";
import { COLOR_BACKGROUND } from "@/comn/features/foundation";

/*
 * Role Management List
 * !== 역할 관리 목록 ==!
 */
export const PTLI0315001Q = (): JSX.Element => {
    const { pgeUid } = usePage();
    const modal = useModal();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const [docCdVal, setDocCdVal] = useState();
    const modalId = "apiTknFormModal";

    useResource({
        defaultSchema: [{ area: "comnCd", comnCd: "CGM0176" }],
    });

    const form = {
        apiTknSrch: useForm({
            defaultSchema: SF_API_TKN_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
        apiTkn: useForm({
            defaultSchema: SF_API_TKN,
            defaultValues: {},
        }),
    };

    const grid = {
        apiTkn: useGrid({
            defaultSchema: SG_API_TKN_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getApiTknList: useFetch({
            api: (page = grid.apiTkn.page) => {
                return APIS.getApiTknList(form.apiTknSrch.getValues(), page, grid.apiTkn.size);
            },
            enabled: true,
            key: [grid.apiTkn.page, grid.apiTkn.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.apiTknSrch.getValues(),
                    page: grid.apiTkn.page,
                    size: grid.apiTkn.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),

        getApiTkn: useFetch({
            api: (data) => {
                return APIS.getApiTkn(data);
            },
            onSuccess: () => {},
            onError: () => {},
        }),

        saveApiTkn: useFetch({
            api: (data) => {
                return APIS.saveApiTkn(data);
            },
            onSuccess: () => {
                modal.closeModal(modalId);
                handler.refreshGrid();
            },
            onError: () => {
                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),

        deleteApiTkn: useFetch({
            api: (data) => {
                const { inexTpCd, tknNm } = data;
                return APIS.deleteApiTkn(inexTpCd, tknNm);
            },
            onSuccess: () => {
                handler.refreshGrid();
            },
            onError: () => {
                modal.openModal({
                    content: "msg.00006", // An error occurred during processing.
                });
            },
        }),
    };
    const handler = {
        refreshGrid: () => {
            fetch.getApiTknList.fetch(grid.apiTkn.page);
        },
        openApiTknForm: () => {
            modal.openModal({
                id: modalId,
                content: <ApiTknForm form={form.apiTkn} handler={handler} />,
                size: "md",
            });
        },
        searchApiTknGrid: (page: number = 0) => {
            form.apiTknSrch.handleSubmit(
                () => {
                    grid.apiTkn.setPage(page);
                    fetch.getApiTknList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        saveApiTkn: () => {
            form.apiTkn.handleSubmit(
                () => {
                    const data = form.apiTkn.getValue();

                    modal.openModal({
                        content: "msg.00101", // Do you want to save ? !== 저장 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.saveApiTkn.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        deleteApiTkn: () => {
            form.apiTkn.handleSubmit(
                () => {
                    const selectRow = grid.apiTkn.getSelectedRow();
                    if (!selectRow) {
                        toast.showToast({ type: "warning", content: "msg.ptl.00683" });
                        return null;
                    }
                    if ("N" !== selectRow.delYn) {
                        toast.showToast({ type: "warning", content: "msg.com.00117" });
                        return null;
                    }

                    modal.openModal({
                        content: "msg.00103", // Do you want to save ? !== 삭제 하시겠습니까 ? ==!
                        onConfirm: () => {
                            fetch.deleteApiTkn.fetch(selectRow);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
    };
    const render = {
        row: (row: any, context: any) => {
            if (row.delYn === "Y") {
                context.backgroundColor = "red";
            }

            return true;
        },
        radio: (row: any, context: any) => {
            if (row.delYn === "Y") {
                return false;
            }

            return true;
        },
        /*
        row: (row: any, context: any) => {
                // row : 해당 row 의 데이터(rowValues)
                // return 값이 true 이면 row 보임
                // return 값이 false 이면 row 숨김
                // context 의 속성을 변경하여 row 의 바탕색 변경 가능
                if (row.mrn === "12345") {
                       context.backgroundColor = "red"; // 3가지 색상 옵션 red , yellow , blue 
                  }
                return row.mrn !== "12345";
            },
        */
    };

    useEffect(() => {}, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.apiTknSrch.schema.inexTpCd} />
                            <Group.Control {...form.apiTknSrch.schema.tknNm} />
                        </Group.Row>
                    </Group.Section>
                    <Layout>
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.apiTknSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role={"search"}
                                onClick={() => {
                                    handler.searchApiTknGrid();
                                }}
                            />
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Layout direction="col">
                            <Layout direction="row">
                                <Layout.Left>
                                    <Button
                                        role="excelDown"
                                        onClick={() => {
                                            grid.apiTkn.exportExcel();
                                        }}
                                    />
                                </Layout.Left>
                                <Layout.Right>
                                    <Button
                                        role="gridAdd"
                                        onClick={() => {
                                            handler.openApiTknForm();
                                        }}
                                    />
                                    <Button role="gridDelete" onClick={handler.deleteApiTkn} />
                                </Layout.Right>
                            </Layout>
                            <Grid {...grid.apiTkn.grid} data={fetch.getApiTknList.data?.apiTknList} render={render} />
                        </Layout>
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};

const ApiTknForm = (props: any) => {
    const { form, handler } = props;
    return (
        <Group>
            <Group.Body>
                <Group.Section>
                    <Group.Row>
                        <Group.Control {...form.schema.inexTpCd} />
                        <Group.Control {...form.schema.tknNm} />
                    </Group.Row>
                </Group.Section>
                <Layout>
                    <Layout.Left>
                        <Button role={"reset"} onClick={() => form.reset()} />
                    </Layout.Left>
                    <Layout.Right>
                        <Button
                            role={"save"}
                            onClick={() => {
                                handler.saveApiTkn();
                            }}
                        />
                    </Layout.Right>
                </Layout>
            </Group.Body>
        </Group>
    );
};
